import ApiService from "./api.service";

const RegistrationOfAthleteService = {
  GetList(
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    oblastid,
    regionid,
    regionsectorid,
    genderid,
    sporttypeid,
    sportTypeCategoryId,
    agecategoryid,
    docyear,
    seasonid,
    lang,
    statusid
  ) {
    if (statusid == null || statusid === undefined|| statusid === '') {
      statusid = 0;
    }
    return ApiService.get(
      `/RegistrationOfAthlete/GetList?Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&oblastid=${oblastid}&regionid=${regionid}&regionsectorid=${regionsectorid}&genderid=${genderid}&sporttypeid=${sporttypeid}&sportTypeCategoryId=${sportTypeCategoryId}&agecategoryid=${agecategoryid}&docyear=${docyear}&seasonid=${seasonid}&lang=${lang}&statusid=${statusid}`
    );
  },
  Get(id) {
    return ApiService.get(`/RegistrationOfAthlete/Get?id=${id}`);
  },
  Update(data) {
    return ApiService.post(`/RegistrationOfAthlete/Update`, data);
  },
  Delete(id) {
    return ApiService.delete(`/RegistrationOfAthlete/Delete?id=${id}`);
  },
  Approve(id) {
    return ApiService.post(`/RegistrationOfAthlete/Approve?id=${id}`);
  },
  CancelApproval(id) {
    return ApiService.post(`/RegistrationOfAthlete/CancelApproval?id=${id}`);
  },
  RegistrationOfAthleteFill(mobilenumber) {
    return ApiService.post(
      `/RegistrationOfAthlete/RegistrationOfAthleteFill?mobilenumber=${mobilenumber}`
    );
  },
};
export default RegistrationOfAthleteService;
